module.exports = __webpack_public_path__ + "static/img/meter_2.5657ef30.gif";